import { useLocation } from "react-router-dom";
import Header from "./header/Header";

export default function Layout() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");

  // 어드민 페이지에서는 헤더를 렌더링하지 않음
  if (isAdminPage) {
    return null;
  }

  return (
    <>
      <Header />
    </>
  );
}
